// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import ProductScratchAndDentAttributes, {
    ScratchAndDentAttributesStyles,
} from "@plumberssupply/App/Components/Product/ProductScratchAndDentAttributes";
import { xPartNumberStyle } from "@plumberssupply/App/SharedStyle/ProductPartNumberStyle";
import { mergeWithCss } from "@plumberssupply/XDL/Utilities";
import React from "react";
import { css } from "styled-components";

type Props = WidgetProps;

export const productDetailsScratchAndDentAttributesStyles: ScratchAndDentAttributesStyles = {
    labelText: {
        ...mergeWithCss(xPartNumberStyle.label, {
            size: 16,
            weight: 800,
            css: css`
                line-height: 26px;
            `,
        }),
    },
    valueText: {
        ...mergeWithCss(xPartNumberStyle.value, {
            size: 16,
            css: css`
                margin: 4px 0;
            `,
        }),
    },
    attributeWrapper: {
        css: css`
            &&&& {
                -webkit-line-clamp: unset;
            }
        `,
    },
};

const styles = productDetailsScratchAndDentAttributesStyles;
const productDetailsScratchAndDentAttributes: React.FC<Props> = () => {
    return <ProductScratchAndDentAttributes extendedStyles={styles} />;
};

const widgetModule: WidgetModule = {
    component: productDetailsScratchAndDentAttributes,
    definition: {
        displayName: "Scratch and Dent Attributes",
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
    },
};

export default widgetModule;
